module.exports = __webpack_public_path__ + "img/15.dea17295.png";